import React from 'react';
import { bidiText } from '../../utils/bidiText';

/**
 * Component for displaying weekly notices
 * @param {Object} props - Component props
 * @param {Array} props.weeklyNotices - Array of weekly notices
 */
function NoticesSection({ weeklyNotices }) {
  return (
    <section className="weekly-notices">
      <h2 className="heading">Notices</h2>
      <div id="notices-content">
        {weeklyNotices.map((notice, index) => (
          <li dir="rtl" key={index}>{bidiText(notice)}</li>
        ))}
      </div>
    </section>
  );
}

export default NoticesSection;
